"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Therm = exports.MegaBtu = exports.KiloBtu = exports.Btu = exports.WattSecond = exports.WattHour = exports.GigaWattHour = exports.MegaWattHour = exports.KiloWattHour = exports.Megajoule = exports.Kilojoule = exports.NewtonMeter = exports.Joule = void 0;
var uom_1 = require("uom");
exports.Joule = uom_1.UnitFormat.createUnitFormat("J", 2);
exports.NewtonMeter = uom_1.UnitFormat.createUnitFormat("Nm", 0);
exports.Kilojoule = uom_1.UnitFormat.createUnitFormat("kJ", 2);
exports.Megajoule = uom_1.UnitFormat.createUnitFormat("MJ", 0);
exports.KiloWattHour = uom_1.UnitFormat.createUnitFormat("kWh", 1);
exports.MegaWattHour = uom_1.UnitFormat.createUnitFormat("MWh", 0);
exports.GigaWattHour = uom_1.UnitFormat.createUnitFormat("GWh", 0);
exports.WattHour = uom_1.UnitFormat.createUnitFormat("Wh", 2);
exports.WattSecond = uom_1.UnitFormat.createUnitFormat("Ws", 4);
exports.Btu = uom_1.UnitFormat.createUnitFormat("BTU", 3);
exports.KiloBtu = uom_1.UnitFormat.createUnitFormat("MBTU", 3);
exports.MegaBtu = uom_1.UnitFormat.createUnitFormat("MMBTU", 3);
exports.Therm = uom_1.UnitFormat.createUnitFormat("Therm", 3);
//# sourceMappingURL=energy-format.js.map